module.exports = __webpack_public_path__ + "static/media/logo_white_300.6c3e95a6.png";